<template lang="pug">
  #ChatGroupPushFooter.inputArea.border-top.position-fixed.w-100(
    style="bottom: 0;"
  )
    b-card.border-0(
      bg-variant="light",
      class="text-center",
      v-b-toggle.toolCollapse,
      style="outline: none; color: #FFF;"
    )
      span.mr-2 工具列
      i.fas.fa-angle-up.fa-lg.arrowIcon
    b-collapse#toolCollapse(
      v-model="toolCollapseShow",
      visible
    )
      b-card.border-0(
        bg-variant="light"
      )
        .row.text-center
          .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
            b-img(
              :src="iconUrl.IconChat",
              alt="Chat Image",
              style="width: 50px;height: 50px;",
              @click="openModelHandler('message')"
            )
            small.w-100.mb-0 群發訊息
          .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
            b-img(
              :src="iconUrl.IconImg",
              alt="Send Image",
              style="width: 50px;height: 50px; style='color: #000'",
              onclick="imgUpload.click()"
            )
            small.w-100.mb-0 相片
            input.d-none(
              type="file",
              accept="image/*",
              id="imgUpload",
              @change="fileUploadHandler('image')",
              ref="imgUploadInput"
            )
          .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
            b-img(
              :src="iconUrl.IconVideo",
              alt="Send Video",
              style="width: 50px;height: 50px;",
              onclick="videoUpload.click()"
            )
            small.w-100.mb-0 影片
            input.d-none(
              type="file",
              accept="video/*",
              id="videoUpload",
              @change="fileUploadHandler('video')",
              ref="videoUploadInput"
            )
          .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
            b-img(
              :src="iconUrl.IconSticker",
              alt="Send Sticker",
              style="width: 50px;height: 50px;",
              @click="openModelHandler('sticker')"
            )
            small.w-100.mb-0 貼圖
          .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
            b-img(
              :src="iconUrl.IconTemp",
              alt="Send Temp",
              style="width: 50px;height: 50px;",
              @click="openModelHandler('temp')"
            )
            small.w-100.mb-0 訊息模板
          //- .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
          //-   b-img(
          //-     :src="iconUrl.IconReserve",
          //-     alt="Send Reservation",
          //-     style="width: 50px;height: 50px;",
          //-     @click="openModelHandler('reservation')"
          //-   )
          //-   small.w-100.mb-0 顧客預約
          //-.col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
          //-  b-img(
          //-  :src="iconUrl.IconInvite",
          //-   alt="Send Invitation",
          //-    style="width: 50px;height: 50px;",
          //-    @click="openModelHandler('invitation')"
          //-  )
          //-  small.w-100.mb-0 邀請函
</template>

<script>
import IconChatUrl from '@/assets/images/icon/icon_white_message.png';
import IconSendUrl from '@/assets/images/icon/icon_arrow_right.png';
import IconShowToolUrl from '@/assets/images/icon/icon_plus.png';
import IconImgUrl from '@/assets/images/icon/icon_white_img.png';
import IconVideoUrl from '@/assets/images/icon/icon_white_video.png';
import IconStickerUrl from '@/assets/images/icon/icon_white_sticker.png';
import IconTempUrl from '@/assets/images/icon/icon_white_temp.png';
import IconReserveUrl from '@/assets/images/icon/icon_white_reserve.png';
import IconInviteUrl from '@/assets/images/icon/icon_white_invite.png';

export default {
    name: 'ChatGroupPushFooter',
    props: {
      user: {
        type: Object,
        default: null
      }
    },
    data() {
        return {
            iconUrl: {
              IconChat: IconChatUrl,
              IconSend: IconSendUrl,
              IconShowTool: IconShowToolUrl,
              IconImg: IconImgUrl,
              IconVideo: IconVideoUrl,
              IconSticker: IconStickerUrl,
              IconTemp: IconTempUrl,
              IconReserve: IconReserveUrl,
              IconInvite: IconInviteUrl,
            },
            toolCollapseShow: true,
            text: null
        };
    },
    methods: {
      sendMsgHandler() {
        const vm = this;
        if (!vm.text || vm.text === '') return;
        vm.$emit('sendHandler', {
          type: 'text',
          text: vm.text
        });
        vm.text = '';
        this.toolCollapseShow = false;
      },
      fileUploadHandler(type) {
        const vm = this;
        let obj;
        switch (type) {
          case 'image':
            obj = vm.$refs.imgUploadInput;
            break;
          case 'video':
            obj = vm.$refs.videoUploadInput;
            break;
          default:
            break;
        }
        if (!obj) return;
        if (!obj.files[0]) return;
        const file = obj.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          // 取得路徑
          const src = e.target.result;

          // 傳送事件到父元件
          const form = new FormData();
          form.append(type, file);
          const data = {
            file: form
          };

          vm.$emit('sendHandler', {
            type,
            file: data,
            src
          });
          obj.value = null;
          vm.toolCollapseHandler();
        };
      },
      // 關閉工具彈窗
      toolCollapseHandler() {
        this.toolCollapseShow = !this.toolCollapseShow;
      },
      openModelHandler(type) {
        const vm = this;
        switch (type) {
          case 'message':
            vm.$EventBus.$emit('openTextPushModel');
            break;
          case 'sticker':
            vm.$EventBus.$emit('openStickerModel');
            break;
          case 'temp':
            vm.$EventBus.$emit('openTempModel');
            break;
          case 'reservation':
            vm.$swal.fire({
              title: '載入中，請稍候',
              allowOutsideClick: false,
              heightAuto: false,
              willOpen: () => {
                vm.$swal.showLoading();
              }
            });
            // 取得預約時間列表
            vm.$store.dispatch('sa_reservation/getReservationTimeListHandler')
              .then(() => {
                // 取得預約服務選項
                vm.$store.dispatch('sa_reservation/getReservationTypeListHandler')
                  .then(() => {
                    vm.$swal.close();
                    vm.$EventBus.$emit('openReservationModel');
                  });
              });
            break;
          case 'tag':
            vm.$swal.fire({
              title: '載入中，請稍候',
              allowOutsideClick: false,
              willOpen: () => {
                vm.$swal.showLoading();
              }
            });

            // 取得所有標籤
            vm.$store.dispatch('sa_reservation/getTagsHandler')
              .then(() => {
                // 取得該使用者的標籤
                vm.$store.dispatch('sa_reservation/getMemberTagsHandler', `${vm.user.member_uuid || vm.user.member_line_uuid}`)
                  .then(() => {
                    vm.$swal.close();
                    vm.$EventBus.$emit('openTagModel', vm.user);
                  });
              });
            break;
          case 'invitation':
            vm.$EventBus.$emit('openInvitationModel');
            break;
          default:
            break;
        }
         vm.toolCollapseHandler();
      }
    }
};
</script>

<style lang="scss" scoped>
.arrowIcon {
  transition: all .3s;
}

.collapsed {
  .arrowIcon {
    transition: all .3s;
    transform: rotate(0deg);
  }
}

.not-collapsed {
  .arrowIcon {
    transform: rotate(180deg);
  }
}

.card-body{
  background-color: $COLOR;
}

small {
  color: $LOGOBGCOLOR;
}
</style>
